export enum PRICE_DISPLAY_TYPE {
  DECIMALS = 'decimals',
  NO_DECIMALS_FLOOR = 'noDecimalsFloor',
  NO_DECIMALS_CEIL = 'noDecimalsCeil',
  NO_DECIMALS_ROUND = 'noDecimalsRound',
}
